module.exports = __webpack_public_path__ + "img/code-json.7520687b.svg";